import { ESTIMATE_STATUSES } from './constants';

export const ESTIMATE_STATUSES_DATA = {
  [ESTIMATE_STATUSES.NEW]: {
    id: ESTIMATE_STATUSES.NEW,
    name: 'Продолжить оценку',
    icon: '$ui-time',
    color: 'redesignPrimary',
  },
  [ESTIMATE_STATUSES.FINISH]: {
    id: ESTIMATE_STATUSES.FINISH,
    name: 'Оценено мной',
    icon: '$ui-check',
    color: 'redesignSuccess',
  },
};

export const ESTIMATE_STATUSES_LIST = Object.values(ESTIMATE_STATUSES_DATA);

export default {
  ESTIMATE_STATUSES_DATA,

  ESTIMATE_STATUSES_LIST,
};
